import classNames from 'classnames';

import { Skeleton } from '@zooplus/ui-components';

import commonStyles from '@styles/common.module.scss';

import styles from './checkout-skeleton.module.scss';

interface CheckoutSkeletonProps {
  isFullPage: boolean;
}

export const CheckoutSkeleton = ({ isFullPage }: CheckoutSkeletonProps) => {
  return isFullPage ? (
    <div className={styles.container} data-testid="full-page-checkout-skeleton">
      <div className={commonStyles.headerPlaceholder}>
        <Skeleton width="100%" height="100%" />
      </div>
      <div className={styles.content}>
        <Skeleton width="328px" height="48px" />
        <Skeleton height="18px" width="320px" />
        <Skeleton height="50px" width="210px" />
        <Skeleton height="200px" width="250px" />
      </div>
      <div className={styles.footer}>
        <Skeleton width="100%" height="180px" />
      </div>
    </div>
  ) : (
    <div className={styles.recoSkeleton} data-testid="checkout-skeleton">
      <Skeleton width="300px" height="35px" />
      <div className={styles.skeletonCards}>
        <CheckoutSkeletonCard />
        <CheckoutSkeletonCard />
        <CheckoutSkeletonCard />
      </div>
    </div>
  );
};

export const EmptyCartSkeleton = () => {
  return (
    <div
      className={classNames(styles.container, styles.emptyCartSkeleton)}
      data-testid="empty-cart-skeleton">
      <div className={styles.content}>
        <Skeleton width="328px" height="48px" />
        <Skeleton height="18px" width="320px" />
        <Skeleton height="50px" width="210px" />
        <div className={styles.cartBox}>
          <Skeleton height="200px" width="100%" />
        </div>
      </div>
    </div>
  );
};

export const CheckoutSkeletonCard = () => {
  return (
    <div className={styles.skeletonCard}>
      <Skeleton shape="square" width="180px" />
      <Skeleton height="24px" width="45%" />
      <Skeleton height="16px" width="95%" />
      <Skeleton height="16px" width="95%" />
      <Skeleton width="240px" height="48px" />
    </div>
  );
};
